import { GetContactActivitiesQuery, useGetContactActivitiesQuery } from "generated/graphql";
import { useMemo } from "react";

export type OpportunityActivityRow = NonNullable<GetContactActivitiesQuery["getContactActivities"]>["data"][number];

type UseOpportunityActivitiesArgs = {
  contactId?: string | null;
  opportunityId?: string | null;
  first?: number;
  page?: number;
};

export const useOpportunityActivities = ({
  contactId,
  opportunityId,
  first = 50,
  page = 1,
}: UseOpportunityActivitiesArgs) => {
  const { data, loading, error } = useGetContactActivitiesQuery({
    variables: {
      contactId: contactId ?? "",
      opportunityId: opportunityId ?? undefined,
      first,
      page,
    },
    skip: !contactId || !opportunityId,
    fetchPolicy: "cache-and-network",
  });

  const activities = useMemo(() => data?.getContactActivities?.data ?? [], [data]);

  return { activities, loading, error } as const;
};
